// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__3flVu","tab_type_current":"tab_tab_type_current__1MQ31"};